export const GET_BUILDING_KIND_LIST = '/building_kind/get_list';
export const SHOW_DATA = '/building_kind/show_data';
export const CREATE_DATA = '/building_kind/create_data';
export const UPDATE_DATA = '/building_kind/update_data';
export const REMOVE_DATA = '/building_kind/remove_data';

export const GET_BUILDING_STRUCTURAL_TYPE_LIST = '/building/get_structural_type_list';
export const SHOW_STRUCTURAL_TYPE = '/building/show_structural_type_data';
export const CREATE_STRUCTURAL_TYPE = '/building/create_structural_type_data';
export const UPDATE_STRUCTURAL_TYPE = '/building/update_structural_type_data';
export const REMOVE_STRUCTURAL_TYPE = '/building/remove_structural_type_data';

export const GET_ORDINANCE_REVISION_LIST = '/building/get_ordinance_revision_list';
